export default __webpack_public_path__ + "static/media/guide@3x.320bf652.webp";